import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";

// Vuetify 4 defaults every input to the `filled` variant, which draws a
// background fill and an underline. That underline is drawn straight across
// the bottom of the control, so on the dialog's `rounded` inputs it cut a
// line under the pill; it also clashed with the rest of the app, which was
// already outlined under Vuetify 2. Set the variant once here so every
// input in the app has the same shape, instead of a `variant` prop per
// field drifting from view to view.
const INPUT_DEFAULTS = { variant: "outlined" };

export default createVuetify({
  icons: { defaultSet: "mdi" },
  // Vuetify 4 defaults `theme.defaultTheme` to "system", so an OS in dark
  // mode got Vuetify's dark palette (white on-surface text) on top of the
  // app's hard-coded light design (`--ln-*` tokens in index.html): white
  // text on white dialogs. The app has no dark design, so pin light.
  // `primary` keeps the Vuetify 2 default (#1976D2), which is also the
  // app's own `--ln-accent`; Vuetify 4's light primary is #1867C0.
  theme: {
    defaultTheme: "light",
    themes: { light: { colors: { primary: "#1976D2" } } },
  },
  defaults: {
    VTextField: INPUT_DEFAULTS,
    VSelect: INPUT_DEFAULTS,
    VTextarea: INPUT_DEFAULTS,
    VAutocomplete: INPUT_DEFAULTS,
    VCombobox: INPUT_DEFAULTS,
    VFileInput: INPUT_DEFAULTS,
  },
});
